import React from 'react';

import exclamation from '../../../../assets/images/exclamation.svg';

import './InlineMessage.scss';

function NewIClassMinBalanceMessage() {
  return (
    <div className="inline-fund-message">
      <div className="inline-fund-message_min-balance-icon">
        <img alt="warning icon" src={exclamation} className="inline-icon" />
      </div>
      <div className="inline-fund-message_min-balance-message">
        I Class shares require a minimum investment of $50,000.
      </div>
    </div>
  );
}

export default NewIClassMinBalanceMessage;
